<ng-template #IPchecking>{{ 'login-Page.checking' | translate }}</ng-template>  
<div *ngIf="!isAuthenticated && !isMobile" class="login-background">
    <div class="login-wrapper justify-content-center">
        <div class="row container-fluid">
            <div class="col-7 login-left-panel">
                <div class="title-wrapper">
                    <h3 class="login-title">
                        {{ 'login-Page.title' | translate }}
                    </h3>
                    <span>
                        {{ 'login-Page.welcome' | translate }}
                    </span>
                </div>
                <form [formGroup]="loginForm" enctype="multipart/form-data" (ngSubmit)="login()"
                    role="form" name=loginForm autocomplete="off" class="login-form">
                    <div class="row container-fluid flex-full-width credentials-input">    
                        <div class="field flex-full-width">
                            <input type="text" class="flex-full-width" name="username" id="username" placeholder="Username"
                                formControlName="username" (keyup.enter)="tabUser()" required>
                        </div>
                    </div>
                    <div class="row container-fluid flex-full-width credentials-input">
                        <div class="field flex-full-width">
                            <input type="password" class="flex-full-width" name="password" id="password" placeholder="Password"
                                formControlName="password" (keyup.enter)="login()" required>
                        </div>
                    </div>
                    <div class="row container-fluid flex-full-width credentials-input" style="margin-bottom: 0px;">
                        <div class="field flex-full-width">
                            <a target="_blank" href="{{ 'forgotPassword' | routerPipe }}" class="row justify-content-center" style="margin-left: auto;">{{ 'login-Page.forgotPW' | translate }}</a>
                        </div>
                    </div>
                    <div class="row">
                        <button type="submit" class="btn btn-primary form-control login-button" [disabled]="isButtonDisabled">
                            <span class="login-text">{{ 'login-Page.login' | translate }} </span>
                            <span class="button-spinner" *ngIf="isButtonDisabled"></span>
                        </button>
                    </div>                
                </form>
            </div>
            <div class="col-5">
                <img class="login-image" src="assets/images/login-splash.png"/>
            </div>
        </div>
        <div class="login-info">
            <h4 class="row justify-content-center login-notSubbed" style="margin-top:50px">{{ 'login-Page.notSubbed' | translate }}</h4>
            <a target="_blank" href="{{ 'learnMore' | routerPipe }}" class="row justify-content-center login-learnMore" style="margin-bottom: 25px">{{ 'login-Page.learnMore' | translate }}</a>
            <p class="row justify-content-center login-contact">{{ 'login-Page.haveTrouble' | translate }}</p>
            <p class="row justify-content-center login-contact">{{ 'login-Page.email' | translate }}</p>
            <p class="row justify-content-center login-contact">{{ 'login-Page.tel' | translate }}</p>
            <p class="row justify-content-center login-contact">
                {{ 'login-Page.ip' | translate }}
                <span *ngIf="userIp$ | async as userIp; else IPchecking" class="nowidth">{{ userIp }}</span>
            </p>
        </div>
    </div>
</div>
<!-- MOBILE -->
<div *ngIf="!isAuthenticated && isMobile" class="login-mobile-container">
    <div class="login-page">

        <div class="login-card">
          <div class="card-top-bar"></div>

          <div class="card-content">
            <h3 class="card-title">CPhA Hub</h3>
            <p class="welcome-text">Welcome back!</p>

            <form [formGroup]="loginForm" (ngSubmit)="login()">
              <input type="text" placeholder="Username" formControlName="username" class="login-input" />
              <input type="password" placeholder="Password" formControlName="password" class="login-input" />
              <a class="forgot-link" [href]="'forgotPassword' | routerPipe">Forgot password?</a>
              <button class="login-btn" type="submit">Sign In</button>
            </form>
            
          </div>
        </div>
        <div class="login-info">
                <h4 class="row justify-content-center login-notSubbed" style="margin-top:50px">{{ 'login-Page.notSubbed' | translate }}</h4>
                <a target="_blank" href="{{ 'learnMore' | routerPipe }}" class="row justify-content-center login-learnMore" style="margin-bottom: 25px">{{ 'login-Page.learnMore' | translate }}</a>
                <p class="row justify-content-center login-contact">{{ 'login-Page.haveTrouble' | translate }}</p>
                <p class="row justify-content-center login-contact">{{ 'login-Page.email' | translate }}</p>
                <p class="row justify-content-center login-contact">{{ 'login-Page.tel' | translate }}</p>
                <p class="row justify-content-center login-contact">
                    {{ 'login-Page.ip' | translate }}
                    <span *ngIf="userIp$ | async as userIp; else IPchecking" class="nowidth">{{ userIp }}</span>
                </p>
        </div>
    </div>
</div>

<ng-template #errorModal>
  <div class="modal-body">
    <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="errorModalRef?.hide()">
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
    <h4 class="modal-title pull-left error">{{ 'login-Page.error' | translate }}</h4>
    
    <div class="login-error justify-content-center" *ngIf="loginErrorMessage$ | async as message">
        <div *ngIf="message != ''" [innerHTML]="'error-message.' + message | translate"></div>                
    </div>
    <button type="button" class="btn btn-danger close-button" (click)="errorModalRef?.hide(); closeModalForErrorCode();">{{ 'login-Page.close' | translate }}</button>
  </div>
</ng-template>